module.exports = __webpack_public_path__ + "static/media/logo-spin-white.401dc6a1.svg";